var inputs = document.getElementsByClassName("custom-selector__type-type"),
    x = inputs.length;
while (x--)
    if (inputs[x].type === "radio")
        inputs[x].addEventListener(
            "change",
            function (e) {
                const _this = this;
                // console.log("Checked: " + this.checked);
                // console.log("Name: " + this.name);
                // console.log("Value: " + this.value);

                // var selectorsArr = document.querySelectorAll(
                //     ".custom-selector__options"
                // );

                const selectorsList = this.closest(
                    ".accordion"
                ).querySelectorAll(".custom-selector__options");

                for (var i = 0; i < selectorsList.length; ++i) {
                    selectorsList[i].classList.remove("selected");
                }

                const optionsValues = _this.value;
                const optionsValuesElement =
                    document.getElementById(optionsValues);
                optionsValuesElement.classList.toggle("selected");

                // optionsValuesElement.style.backgroundColor = "red";

                // _this
                //     .closest(".accordion")
                //     .querySelector(".custom-selector__options")
                //     .classList.remove("selected");
            },
            0
        );

var options = document.getElementsByClassName(
        "custom-selector__options-option"
    ),
    x = options.length;
while (x--)
    if (options[x].type === "radio")
        options[x].addEventListener(
            "change",
            function (e) {
                // console.log("Checked: " + this.checked);
                // console.log("Name: " + this.name);
                // console.log("Value: " + this.value);

                const _this = this;

                setTimeout(function () {
                    _this
                        .closest(".custom-selector__accordion")
                        .removeAttribute("open");
                }, 500);

                this.closest(".accordion").querySelector(
                    ".selected-value"
                ).textContent = this.value;
            },
            0
        );
